export default __webpack_public_path__ + "static/media/chipperParts.d5a13c81.png";